/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTipoPraticaDocumentoDTO } from '../model/models';
import { TipoPraticaDocumentoDTO } from '../model/models';
import { TipoPraticaDocumentoPatchForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface DeleteTipoPraticaDocumentoRequestParams {
    id: string;
    idDocumento: string;
    version: number;
}

export interface DownloadTipoPraticaDocumentoRequestParams {
    id: string;
    idDocumento: string;
}

export interface ListTipoPraticaDocumentiRequestParams {
    id: string;
    pageable: Pageable;
}

export interface UpdateTipoPraticaDocumentoRequestParams {
    id: string;
    idDocumento: string;
    tipoPraticaDocumentoPatchForm: TipoPraticaDocumentoPatchForm;
}

export interface UploadTipoPraticaDocumentoRequestParams {
    id: string;
    file: Blob;
    descrizione?: string;
}


export interface TipoPraticaDocumentoControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Rimuove un documento del bando.
     * Query param \&#39;version\&#39;. 404 se il documento non appartiene al bando; 409 version stale.
     * @endpoint delete /api/v1/gestione/tipi-pratica/{id}/documenti/{idDocumento}
* @param requestParameters
     */
    deleteTipoPraticaDocumento(requestParameters: DeleteTipoPraticaDocumentoRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Scarica un documento PDF del bando.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{id}/documenti/{idDocumento}/download
* @param requestParameters
     */
    downloadTipoPraticaDocumento(requestParameters: DownloadTipoPraticaDocumentoRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Elenco paginato dei documenti PDF del bando (default: dal piu\&#39; vecchio, 20 per pagina).
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{id}/documenti
* @param requestParameters
     */
    listTipoPraticaDocumenti(requestParameters: ListTipoPraticaDocumentiRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaDocumentoDTO>;

    /**
     * Modifica la descrizione di un documento del bando.
     * Descrizione vuota o assente la cancella. 409 version stale.
     * @endpoint patch /api/v1/gestione/tipi-pratica/{id}/documenti/{idDocumento}
* @param requestParameters
     */
    updateTipoPraticaDocumento(requestParameters: UpdateTipoPraticaDocumentoRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaDocumentoDTO>;

    /**
     * Carica un documento PDF sul bando.
     * Multipart: part \&#39;file\&#39; (PDF, max 10 MB) + campo facoltativo \&#39;descrizione\&#39; (max 500). 422 se il PDF non e\&#39; valido, se la descrizione e\&#39; troppo lunga o se il bando ha gia\&#39; il numero massimo di documenti.
     * @endpoint post /api/v1/gestione/tipi-pratica/{id}/documenti
* @param requestParameters
     */
    uploadTipoPraticaDocumento(requestParameters: UploadTipoPraticaDocumentoRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaDocumentoDTO>;

}
